import { useContext } from "react";

const Footer = () => {
  return (
    <footer className="main-footer">
        <div className="container">
        <div className="row">
            <div className="col-lg-3">
            <div className="about-footer">
                <div className="footer-logo">
                <img src="images/crypto/logo-footer.png" alt="" />
                </div>
                <div className="about-footer-content">
                <p>
                    HyperStake AI combines staking and artificial intelligence to
                    maximize profits and automate DeFi strategies. Join us in
                    revolutionizing decentralized finance with AI-powered staking,
                    mining, and analytics.
                </p>
                </div>
                <div className="footer-social-links">
                <ul>
                    <li>
                    <a href="#">
                        <i className="fa-brands fa-facebook-f" />
                    </a>
                    </li>
                    <li>
                    <a href="#">
                        <i className="fa-brands fa-twitter" />
                    </a>
                    </li>
                    <li>
                    <a href="#">
                        <i className="fa-brands fa-linkedin-in" />
                    </a>
                    </li>
                    <li>
                    <a href="#">
                        <i className="fa-brands fa-instagram" />
                    </a>
                    </li>
                </ul>
                </div>
            </div>
            </div>
            <div className="col-md-3">
            <div className="about-working-hour">
                <h3>Services</h3>
                <ul>
                <li>Staking</li>
                <li>Mining</li>
                <li>AI</li>
                </ul>
            </div>
            </div>
            <div className=" col-md-3">
            <div className="about-service-list">
                <h3>Document</h3>
                <ul>
                <li>
                    <a href="#">About Us</a>
                </li>
                <li>
                    <a href="#">White Paper</a>
                </li>
                <li>
                    <a href="#">Tokenomics</a>
                </li>
                </ul>
            </div>
            </div>
            <div className="col-lg-3">
            {/* About Links Start */}
            <div className="footer-contact">
                <h3>Download App</h3>
                <div className="row">
                <div className="col-md-6 col-sm-12">
                    <img
                    src="images/crypto/footer/chplay.png"
                    alt=""
                    height="50px"
                    />
                </div>
                </div>
            </div>
            {/* About Links End */}
            </div>
        </div>
        <div className="footer-copyright">
            <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
                <div className="footer-copyright-text">
                <p>Copyright 2025 HyperStake AI. All Rights Reserved.</p>
                </div>
            </div>
            <div className="col-lg-6 col-md-6">
                {/* Footer Social Link Start */}
                <div className="footer-links">
                <ul>
                    <li>
                    <a href="#">about us</a>
                    </li>
                    <li>
                    <a href="#">services</a>
                    </li>
                    <li>
                    <a href="#">contact us</a>
                    </li>
                </ul>
                </div>
                {/* Footer Social Link End */}
            </div>
            </div>
        </div>
        {/* Footer Copyright Section End */}
        </div>
  </footer>
  );
};

export default Footer;
